import React from 'react';

const FavoritesPage = () => {
  
  return (
  <div>Favorites</div>
  )
}
export default FavoritesPage;